import { render, staticRenderFns } from "./anchorRoomJY.vue?vue&type=template&id=efb8a304&scoped=true&lang=pug"
import script from "./anchorRoomJY.vue?vue&type=script&lang=js"
export * from "./anchorRoomJY.vue?vue&type=script&lang=js"
import style0 from "./anchorRoomJY.vue?vue&type=style&index=0&id=efb8a304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb8a304",
  null
  
)

export default component.exports